import { render, staticRenderFns } from "./EditConsortiumModal.vue?vue&type=template&id=15c75259&"
import script from "./EditConsortiumModal.vue?vue&type=script&lang=js&"
export * from "./EditConsortiumModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports